import { Right } from "@insightfulscience/shared-utils/either";

/** @type {
	(setId: string, plasmidId: string) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }) => Promise<Right<Promise<import("../interfaces/ISGApiClient").PlasmidSequences>>
} */
const setSequencesData = setId => ({ sgApiClient }) => sgApiClient.getSequences(setId).then(Right);

export default setSequencesData;
